import React, { useState } from 'react';
import i18n from 'i18next';
import { css } from '@emotion/core';
import { isMobile } from 'react-device-detect';
import Button from 'Mui/Button';
import AssignmentIcon from '@material-ui/icons/Assignment';
import PopupWithFixHeader, { modes } from 'client/components/PopupWithFixHeader';
import FormPanel from 'client/components/Result/EntriesInfo/form/FormPanel';
import ViewFormButton from 'client/components/Result/Button/ViewFormButton';
import { system900 } from 'Mui/styles/color';

export default function FormInfoButton({ formIds, entryUuid, needText = false }) {
    const [isPopupOpen, setIsPopupOpen] = useState(false);

    function showFormDataList() {
        setIsPopupOpen(true);
    }
    function closePrizeList() {
        setIsPopupOpen(false);
    }

    return (
        <>
            {!needText ? (
                <Button css={circleButtonStyle} color={system900.color} onClick={showFormDataList}>
                    <AssignmentIcon style={{ fontSize: 24, color: 'inherit' }} />
                </Button>
            ) : (
                <ViewFormButton onClick={showFormDataList} />
            )}

            <PopupWithFixHeader
                show={isPopupOpen}
                title={i18n.t('label.form_records')}
                onClose={closePrizeList}
                mode={isMobile ? modes.COMP : modes.GLOBAL}
            >
                <FormPanel formIds={formIds} entryUuid={entryUuid} />
            </PopupWithFixHeader>
        </>
    );
}
const circleButtonStyle = css`
    min-width: 24px;
    width: 24px;
    height: 24px;
    &:hover {
        background-color: transparent;
    }
`;
